import {
  SET_COTACAO_ID,
} from './mutations.type';

export default {
  [SET_COTACAO_ID](state, id) {
    state.cotacaoId = id;
  },
};
